// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3-XBA","approved":"Status_approved__3GVxu","rejected":"Status_rejected__3vK5-","expired":"Status_expired__V7k4F","label":"Status_label__OgZ78"};